import { render, staticRenderFns } from "./ReminderEditModal.vue?vue&type=template&id=f41adfee"
import script from "./ReminderEditModal.vue?vue&type=script&lang=js"
export * from "./ReminderEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports